module.exports = __webpack_public_path__ + "img/carp_4kl.bf622d97.jpg";